/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Validation_Contact_Name_Too_LongInputs */

const en_case_validation_contact_name_too_long = /** @type {(inputs: Case_Validation_Contact_Name_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name must be at most 200 characters.`)
};

const pt_br2_case_validation_contact_name_too_long = /** @type {(inputs: Case_Validation_Contact_Name_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O nome deve ter no máximo 200 caracteres.`)
};

/**
* | output |
* | --- |
* | "Name must be at most 200 characters." |
*
* @param {Case_Validation_Contact_Name_Too_LongInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_validation_contact_name_too_long = /** @type {((inputs?: Case_Validation_Contact_Name_Too_LongInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Validation_Contact_Name_Too_LongInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_validation_contact_name_too_long(inputs)
	return pt_br2_case_validation_contact_name_too_long(inputs)
});